import "./style.scss";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import DownloadSvg from "@/src/svg/applicationsPage/DownloadSvg";
import SelectDefault from "../../SelectDefault/SelectDefault";
import { FC } from "react";
import ArrowBottom from "@/src/svg/default/ArrowBottom";
import VerticalLine from "../../VerticalLine/VerticalLine";

interface IAPFooter {
  isCurrentPage: string;
  setIsCurrentPage: React.Dispatch<React.SetStateAction<string>>;
  isSelectPagination: string;
  setIsSelectPagination: React.Dispatch<React.SetStateAction<string>>;
  actualQuantityRows: number;
}

const APFooter: FC<IAPFooter> = ({
  isCurrentPage,
  setIsCurrentPage,
  isSelectPagination,
  setIsSelectPagination,
  actualQuantityRows,
}) => {
  const handleChangePagination = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setIsCurrentPage("1");
    setIsSelectPagination(event.target.value);
  };

  const calcActualPage = (number: number) => {
    const newPage = Number(isCurrentPage) + number;
    if (newPage > 0 && newPage <= Math.ceil(actualQuantityRows / Number(isSelectPagination))) {
      setIsCurrentPage(newPage.toString());
    }
  };

  const totalPages = Math.ceil(actualQuantityRows / Number(isSelectPagination));
  const currentPage = Number(isCurrentPage);

  const getPagesToShow = () => {
    const pages: number[] = [];
    const totalPages = Math.ceil(actualQuantityRows / Number(isSelectPagination));
    const currentPage = Number(isCurrentPage);

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      if (currentPage <= 3) {
        pages.push(2, 3, 4);
      } else if (currentPage >= totalPages - 2) {
        pages.push(totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        pages.push(currentPage - 1, currentPage, currentPage + 1);
      }
      pages.push(totalPages);
    }

    return Array.from(new Set(pages)).sort((a, b) => a - b);
  };

  const pagesToShow = getPagesToShow();

  return (
    <div className="applications-page-footer">
      <span className="pag-info">
        Showing {Number(isSelectPagination) * (currentPage - 1) + 1} -{" "}
        {Number(isSelectPagination) * currentPage > actualQuantityRows
          ? actualQuantityRows
          : Number(isSelectPagination) * currentPage}{" "}
        out of {actualQuantityRows}
      </span>
      <div className="applications-page-footer-controllers">
        <div className="pagination">
          <button
            className="pagination-btn prev"
            onClick={() => calcActualPage(-1)}
            disabled={currentPage === 1}
          >
            <ArrowBottom />
          </button>

          {pagesToShow.map((page) => (
            <button
              key={page}
              className={page === currentPage ? "active" : ""}
              onClick={() => setIsCurrentPage(page.toString())}
            >
              {page}
            </button>
          ))}

          <button
            className="pagination-btn next"
            onClick={() => calcActualPage(1)}
            disabled={currentPage === totalPages}
          >
            <ArrowBottom />
          </button>
        </div>

        <div className="pagination-select">
          <SelectDefault
            onChange={handleChangePagination}
            value={isSelectPagination}
            reverse={true}
          >
            <option>1</option>
            <option>5</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
          </SelectDefault>
        </div>
        <VerticalLine />
        <BtnDefault onClick={() => console.log("Download")}>
          <p>Download</p>
          <DownloadSvg />
        </BtnDefault>
      </div>
    </div>
  );
};

export default APFooter;
